import { MinusCircleIcon } from "@heroicons/react/24/outline";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, GetCommanWay, ListCommanWay, UpdateBookingCommanWay, UpdateCommanWay } from "API/commonApi";
import { AxiosResponse } from "axios";
import { Button, Input } from "components";
import { InputTable } from "components/DataTable/InputTable";
import { useFormik } from "formik";
import { debounce } from "lodash";
import moment from "moment";
import { any } from "prop-types";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import { roles } from "utils/constant";
import handleWheel from "utils/handleOnWheel";
import { get_file_url } from "utils/lib-utils";
import { AfDataType as ADT } from "utils/TableColumnData";
import { number, object, string } from "yup";

type OptionType = {
  value: number;
  label: string;
};

interface MotherBagState {
  mode?: string;
  data?: { [key: string]: any }; // Adjust the type based on your data structure
  // Add other properties if needed
}

interface ValuesType {
  destination?: { value: string; label: string };
}

const MotherBagInScan: React.FC = ({}) => {
  let isDisabled = false;
  const navigate = useNavigate();
  const { state } = useLocation();
  const { mode = "add", data = {} } = (state || {}) as MotherBagState; // Check for existence and type assertion

  const [motherBagList, setMotherBagList] = useState<any>([]);
  const [selectedMotherbag, setSelectedMotherbag] = useState<number>(null);

  const [selectedViewMore, setSelectedViewMore] = useState<number>(null);

  const [awbDataList, setAwbDataList] = useState<any>([]);

  const [acceptedAwbNos, setAcceptedAwbNos] = useState<any>([]);
  const [awbScanVal, setAwbScanVal] = useState<any>("");

  const [filterStartDt, setFilterStartDt] = useState<any>(moment().subtract(1, "day").startOf("day"));
  const [filterEndDt, setFilterEndDt] = useState<any>(moment().endOf("day"));

  const [motherbagStatusList, setMotherbagStatusList] = useState<any[]>([]);
  const [selectedMotherbagStatus, setSelectedMotherbagStatus] = useState<any>({});
  const [statusFilter, setStatusFilter] = useState<any>({ value: "", label: "All" });

  const [mySubbranch, setMySubbranch] = useState<any>(false);
  React.useEffect(() => {
    const userD = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : {};
    if (Object.keys(userD).length) {
      setMySubbranch(userD.state.user.subbranch);
    }
  }, []);

  React.useEffect(() => {
    console.log("mySubbranch", mySubbranch);
    if (mySubbranch) {
      setTimeout(refetchData, 200);
    }
  }, [mySubbranch]);

  const { refetch: mbag_status } = useQuery(["MbagStatusList"], () => GetCommanWay("/admin/mbag_status_list", {}, {}), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        console.log(data.data);
        setMotherbagStatusList(data.data);
      }
    },
  });

  useEffect(() => {
    if (selectedMotherbag) {
      console.log(selectedMotherbag);
      setTimeout((x) => {
        awbDataRefetch();
      }, 100);
    }
  }, [selectedMotherbag]);
  const { refetch: awbDataRefetch } = useQuery(
    ["AWBList"],
    () =>
      ListCommanWay(
        "/admin/awbdata/list",
        { mother_bag_id: selectedMotherbag, isInscan: true },
        {
          include: [],
          paginate: 1000,
        }
      ),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        console.log(data);
        if (data.status == "SUCCESS") {
          let mbagData: any = {};
          motherBagList.forEach((m) => {
            if (m.id == selectedMotherbag) {
              mbagData = m;
            }
          });
          let shortAwbs = mbagData.shortAwbs ? mbagData.shortAwbs.split(",") : [];

          let finalAwbs = data.data.data;
          if (shortAwbs.length) {
            finalAwbs = [];
            data.data.data.forEach((a) => {
              if (shortAwbs.includes(a.awb_no)) {
                finalAwbs.push(a);
              }
            });
          }
          setAwbDataList(finalAwbs);
        }
      },
    }
  );
  const { refetch: refetchData } = useQuery(
    ["MotherBagInApi"],
    () =>
      ListCommanWay(
        "/admin/mother_bag/list",
        {
          outscanDone: true,
          isInscan: true,
          delivery_subbranch: mySubbranch,
          $and: {
            $or: {
              $and: {
                createdAt: {
                  $gte: filterStartDt,
                  $lte: filterEndDt,
                },
              },
            },
          },
        },
        { paginate: 10000, include: ["_destination", "_subbranch", "_vendor", "_flight", "_airline"] }
      ),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          setMotherBagList(data.data.data);
        }
      },
    }
  );

  const { mutate: addMotherbag_pod } = useMutation(CreateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Motherbag Status Changed", "success");
        resetForm();
        setAwbDataList([]);
        setSelectedMotherbag(null);
        refetchData();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      //typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      UseToast("Motherbag Status Change error. Try Again OR Contact Admin!", "error");
    },
  });

  const { mutate: ReleaseAwbNosMutate } = useMutation(UpdateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Airwaybill release successfully", "success");
        proceedToInScan();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      //typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      UseToast("Cannot Release Airwaybill Numbers. Try Again OR Contact Admin!", "error");
    },
  });
  const { mutate: InScanMotherbag } = useMutation(UpdateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Motherbag in-scan complete", "success");
        resetForm();
        setAwbDataList([]);
        setAcceptedAwbNos([]);
        setSelectedMotherbag(null);
        refetchData();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      //typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      UseToast("Motherbag in-scan. Try Again OR Contact Admin!", "error");
    },
  });

  const proceedToInScan = () => {
    InScanMotherbag({
      url: "/admin/mother_bag/update/" + selectedMotherbag,
      data: {
        inScanPOD: true,
        inscanDone: true,
        selectedAwbs: acceptedAwbNos,
        status: "RECEIVED",
      },
    });
  };

  const { handleSubmit, handleBlur, values, handleChange, errors, setValues, setErrors, touched, dirty, resetForm, setFieldValue } =
    useFormik({
      validationSchema: object().shape({}),
      initialValues: {
        subbranch: { value: 0, label: "" },
      },
      onSubmit: async (values, { resetForm }) => {
        console.log("values", values);
        console.log("selcted mbag", selectedMotherbag);
        console.log("accpeted", acceptedAwbNos);
        if (!selectedMotherbag) {
          UseToast("Select Motherbag", "error");
          return;
        }
        if (acceptedAwbNos.length == 0) {
          UseToast("Scan atleast 1 Airwaybill", "error");
          return;
        }

        let awbToRelease = [];
        awbDataList.forEach((a) => {
          if (!acceptedAwbNos.includes(a.awb_no)) {
            awbToRelease.push(a.awb_no);
          }
        });

        if (awbToRelease.length > 0) {
          //alert("Cannnot Inscan! missing " + awbToRelease.length + " Airwaybill");
          //return;
          Swal.fire({
            title: "Are you Sure!",
            text: "you want to Declare as Short Piece: " + awbToRelease.join(", "),
            icon: "question",
            confirmButtonText: "Yes",
            showCancelButton: true,
          })
            .then((x) => {
              if (x.isConfirmed) {
                InScanMotherbag({
                  url: "/admin/mother_bag/update/" + selectedMotherbag,
                  data: {
                    shortAwbs: awbToRelease,
                    selectedAwbs: acceptedAwbNos,
                    inScanPOD: true,
                    inscanDone: true,
                    status: "RECEIVED",
                  },
                });
              } else {
                ////proceedToInScan();
              }
            })
            .catch((c) => {
              ////proceedToInScan();
            });
        } else {
          proceedToInScan();
        }
        //mutateUpdateMotherBag(data.id);
        //navigate("/mother_bag/list");
        return;
      },
    });

  const disableEnterKey = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
    }
  };

  const doShowRow = (m: any) => {
    switch (statusFilter.value) {
      case "":
        return true;
        break;
      case "pending":
        return m.outscanDone && !m.inscanDone ? true : false;
        break;
      case "received":
        return m.inscanDone ? true : false;
        break;
    }
  };

  const getModeSvg = (mode) => {
    switch (mode) {
      case "By Train":
        return (
          <svg className="bg-white p-1 rounded-full" xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 24 24">
            \{" "}
            <path
              fill="#B8001F"
              d="M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
            />
          </svg>
        );
      case "By Road":
        return (
          <svg className="bg-gray-400 p-2 rounded-full" xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 48 48">
            <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
              <path d="m0 0h48v48h-48z" fill="#fff" fill-opacity=".01" />
              <g stroke="#000" stroke-width="4" transform="translate(6 5.091863)">
                <path d="m5 .90813664-5 35.99999996" />
                <path d="m36.9287415.90813664-4.9643707 35.95523776" transform="matrix(-1 0 0 1 67.928742 0)" />
                <path d="m18 .90813664v6" />
                <path d="m18 29.9081366v7" />
                <path d="m18 14.9081366v7" />
              </g>
            </g>
          </svg>
        );
      case "By Air":
        return (
          <div className="bg-black-900 p-2 rounded-full w-9 h-9">
            <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 512 512" viewBox="0 0 512 512">
              <path
                fill="#08C2FF"
                d="m490.7 0c-21.3 0-42.7 0-53.3 10.7l-85.3 96h-330.8l-21.3 32 234.7 74.7-64 85.3h-96l-32 32 64 21.3v32c.7 11.5 10.7 21.3 21.3 21.3h32l21.3 64 32-32v-96l85.3-64 74.7 234.7 32-21.3v-330.7l96-85.3c10.7-10.7 10.7-32 10.7-53.4 0-10.6-10.7-21.3-21.3-21.3z"
              />
            </svg>
          </div>
        );
      default:
        return mode;
    }
  };

  return (
    <>
      <h1 className="text-center mb-4 mt-3 text-lg font-semibold underline">Mother Bag IN-SCAN</h1>

      <div className="flex items-center justify-center my-5 gap-3">
        <div>
          From:{" "}
          <input
            type="date"
            className="focus:border-colors2 rounded"
            value={filterStartDt.format("YYYY-MM-DD")}
            onChange={(e: any) => {
              setFilterStartDt(moment(e.target.value).startOf("day"));
            }}
          />
        </div>
        <div>
          To:{" "}
          <input
            type="date"
            className="focus:border-colors2 rounded"
            value={filterEndDt.format("YYYY-MM-DD")}
            onChange={(e: any) => {
              setFilterEndDt(moment(e.target.value).endOf("day"));
            }}
          />
        </div>
        <Button
          type="button"
          className="rounded-md px-2 py-2.5 text-sm font-medium text-white bg-blue-500 border hover:bg-opacity-60 focus:z-10"
          onClick={refetchData}
        >
          Search
        </Button>

        <div className="w-36 ml-10">
          <Select
            className={`flex-1 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block `}
            options={[
              { value: "", label: "All" },
              { value: "pending", label: "Pending" },
              { value: "received", label: "Received" },
            ]}
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e);
            }}
            menuPortalTarget={document.body}
          />
        </div>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
      >
        {/* <div className="grid grid-cols-2 sm:grid-cols-1 gap-4 px-4"> */}
        <div className="flex gap-2 flex-wrap border p-2 rounded-2xl">
          <table className="border text-left px-4 rounded">
            <thead className="border-b">
              <tr>
                <th className="py-2 px-2">Action</th>
                <th>ID.</th>
                <th>Date</th>
                <th>Motherbag No</th>
                <th>Origin</th>
                <th>Destination</th>
                <th className="px-1">Mode</th>
                <th>Total Nos.</th>
                <th>Remark</th>
                <th>Status</th>
                <th>Action</th>
                <th>Last Remark</th>
                <th className="max-w-[300px]">Action</th>
              </tr>
            </thead>
            <tbody>
              {motherBagList.map((m) => {
                return (
                  doShowRow(m) && (
                    <>
                      <tr
                        className={`border-t ${
                          m.status == "SHORT"
                            ? "bg-teal-600 text-white"
                            : m.inscanDone
                            ? "bg-green-500"
                            : m.id == selectedMotherbag
                            ? "bg-yellow-200"
                            : "bg-red-300"
                        }`}
                      >
                        <td>
                          <Button
                            type="button"
                            className="text-xs bg-primary text-white px-1 py-0.5 mr-2 "
                            onClick={() => {
                              setSelectedViewMore(m.id);
                            }}
                          >
                            View
                          </Button>
                          {m.inscanDone && m.status != "SHORT" ? (
                            <>
                              {/*<Button
                          type="button"
                          className="rounded-md px-2 py-1 text-sm font-medium text-white bg-blue-500 border hover:bg-opacity-60 focus:z-10"
                          onClick={() => {
                            setSelectedMotherbag(m.id);
                            resetForm();
                          }}
                        >
                          Show DRS
                        </Button>*/}
                            </>
                          ) : m.id == selectedMotherbag ? (
                            <p className="py-1 px-1 text-sm">Selcted</p>
                          ) : (
                            <Button
                              type="button"
                              className="rounded-md px-2 py-1 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
                              onClick={() => {
                                setSelectedMotherbag(m.id);
                                resetForm();
                              }}
                            >
                              Select
                            </Button>
                          )}
                        </td>
                        <td>{m.id}</td>
                        <td>{moment(m.createdAt, "DD-MM-YYYY").format("DD/MM/YYYY")}</td>
                        <td>
                          {" "}
                          <span
                            className="cursor-pointer hover:underline hover:font-semibold"
                            onClick={() => {
                              navigate("/mother_bag/add", {
                                state: {
                                  mode: "view",
                                  data: m,
                                },
                              });
                            }}
                          >
                            {m.mother_bag_code}
                          </span>
                        </td>
                        <td>{m._subbranch?.branch_name}</td>
                        <td>{m._destination?.city_name}</td>
                        <td>{getModeSvg(m.modeOfPkg)}</td>
                        <td>{m.totalNos}</td>
                        <td>{m.remark}</td>
                        <td>{m.status}</td>
                        <td>
                          {m?.VendorSlips?.length ? (
                            <a
                              href={(m?.VendorSlips?.length && get_file_url(m?.VendorSlips[m?.VendorSlips?.length - 1].slip_url)) || ""}
                              target="_blank"
                              className={`inline-block rounded-md px-2 py-1 text-sm font-medium bg-black-900 border border-gray-200 focus:z-10 mr-1 ${
                                !m?.VendorSlips?.length ? "bg-gray-400 text-gray-600" : "text-white hover:bg-opacity-60"
                              }`}
                            >
                              Slip
                            </a>
                          ): "-"}
                        </td>
                        <td>{m.motherbad_pods && m.motherbad_pods.length > 0 && m.motherbad_pods[0].remark}</td>
                        <td className="flex p-1 gap-1 max-w-[300px]">
                          <Select
                            className={`flex-1 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block `}
                            options={motherbagStatusList}
                            value={selectedMotherbagStatus}
                            onChange={(e) => {
                              setSelectedMotherbagStatus(e);
                            }}
                            styles={{
                              control: (provided, state) => ({
                                ...provided,
                                minHeight: "30px",
                                height: "30px",
                              }),
                              valueContainer: (provided, state) => ({
                                ...provided,
                                height: "30px",
                                padding: "0 6px",
                              }),
                              input: (provided, state) => ({
                                ...provided,
                                margin: "0px",
                              }),

                              indicatorsContainer: (provided, state) => ({
                                ...provided,
                                height: "30px",
                              }),
                            }}
                            menuPortalTarget={document.body}
                          />
                          <Button
                            type="button"
                            className="rounded-md px-2 py-1 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
                            onClick={() => {
                              addMotherbag_pod({
                                url: "/admin/motherbad_pod/create/",
                                data: {
                                  bagId: m.id,
                                  status: selectedMotherbagStatus.value + "",
                                  remark: selectedMotherbagStatus.label,
                                  dateTime: new Date(),
                                },
                              });
                            }}
                          >
                            Save
                          </Button>
                        </td>
                      </tr>
                      {m.id == selectedViewMore && (
                        <tr
                          className={`border-t ${
                            m.inscanDone ? "bg-green-500" : m.id == selectedMotherbag ? "bg-yellow-200" : "bg-red-300"
                          }`}
                        >
                          <td className="px-3 py-2 text-center" colSpan={12}>
                            Actual Wt: {m.realWeight} ----- Vendor: {m._vendor?.vendor_name} ----- Airline: {m._airline?.name} ----- Flight:{" "}
                            {m._flight?.name} ----- Type: {m.type == 2 ? "Console" : "Cargo"}
                          </td>
                        </tr>
                      )}
                    </>
                  )
                );
              })}
            </tbody>
          </table>
          <div className="w-full font-semibold underline text-center mt-5 border-t">Aiwaybill Information</div>

          <div className="w-full text-center">
            Scan AWB No:
            <input
              type="text"
              value={awbScanVal}
              className="bg-blue-200 rounded"
              onKeyDown={disableEnterKey}
              onInput={(e: any) => {
                let found = false;
                awbDataList.forEach((a) => {
                  console.log(a.awb_no == e.target.value, a.awb_no, e.target.value);
                  if (a.awb_no == e.target.value) {
                    found = true;
                  }
                });
                console.log(found, !acceptedAwbNos.includes(e.target.value));

                if (found && !acceptedAwbNos.includes(e.target.value)) {
                  let obj = [...acceptedAwbNos];
                  obj.push(e.target.value);
                  setAcceptedAwbNos(obj);
                  setAwbScanVal("");
                } else {
                  setAwbScanVal(e.target.value);
                }
              }}
            />
          </div>
          <div className="w-full relative overflow-x-auto">
            <table className="w-full text-sm text-left text-black-900">
              <thead className="text-black-900 uppercase font-semibold bg-gray-50 border-y-2">
                <tr>
                  <td className="px-3 py-2">Check</td>
                  <td className="px-3 py-2">No</td>
                  <td className="px-3 py-2">Destination</td>
                  <td className="px-3 py-2">Weight</td>
                  <td className="px-3 py-2">Consignee</td>
                  <td className="px-3 py-2">Contact</td>
                </tr>
              </thead>
              <tbody>
                {awbDataList.map((e) => {
                  return (
                    <tr className={`border-b ${acceptedAwbNos.includes(e.awb_no) ? "bg-green-300" : "bg-white"}`}>
                      <td className="px-3 py-2">{acceptedAwbNos.includes(e.awb_no) ? "YES" : "-"}</td>
                      <td className="px-3 py-2">{e.awb_no}</td>
                      <td className="px-3 py-2">{e.destination}</td>
                      <td className="px-3 py-2">{e.weight}</td>
                      <td className="px-3 py-2">{e.consignee}</td>
                      <td className="px-3 py-2">{e.contact_no}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        {/* </div> */}
        <div className="flex w-full justify-end mt-5 pr-3">
          <Button
            type="submit"
            className="rounded-md inline-block px-4 py-2 text-sm font-medium text-white bg-blue-800 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
          >
            Accept In-Scan
          </Button>
        </div>
      </form>
    </>
  );
};

export default MotherBagInScan;
